// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PEnterOutlinedSvg from "@fishx/icons-svg/es/asn/PEnterOutlined";
import FishxIcon from '../components/FishxIcon';

var PEnterOutlined = function PEnterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PEnterOutlinedSvg
  }));
};

PEnterOutlined.displayName = 'PEnterOutlined';
export default React.forwardRef(PEnterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PEnterOutlined.js
// module id = 3360
// module chunks = 0